import { Anchor, Box, DataTable } from "grommet"
import { Interval, DateTime } from "luxon"

export const PresenceReports = ({ employeeID, workconditions }) => {
  const months = workconditions.reduce((acc, workCondition) => {
    const { starts_on, ends_on } = workCondition

    const start = DateTime.fromISO(starts_on).startOf("month")
    const end = ends_on ? DateTime.fromISO(ends_on) : DateTime.local()
    const interval = Interval.fromDateTimes(start, end)
    const dates = interval.splitBy({ month: 1 }).map(date => ({
      year: date.start.year,
      month: date.start.month,
      url: `/employees/${employeeID}/time-report/${date.start.year}/${date.start.month}`,
    }))

    return [...acc, ...dates]
  }, [])

  return (
    <Box width={{ max: "800px" }}>
      <div className="mobileTableWrapper">
        <DataTable
          className="mobileTable"
          background={["white", "light-1"]}
          columns={[
            {
              property: "year",
              header: "Année",
              sortable: false,
              verticalAlign: "top",
            },
            {
              property: "month",
              header: "Mois",
              sortable: false,
              verticalAlign: "top",
              render: item =>
                new Date(2000, item.month-1, 1).toLocaleString("default", {
                  month: "long",
                }),
            },
            {
              primary: true,
              align: "end",
              property: "url",
              sortable: false,
              verticalAlign: "top",
              render: item => (
                <Anchor
                  href={process.env.REACT_APP_API_BASE_URL + item.url}
                  target="_blank"
                >
                  Télécharger le PDF
                </Anchor>
              ),
            },
          ]}
          onSort={({ property, direction }) => {
            console.log(property, direction)
          }}
          data={months.sort((a, b) => {
            return `${b.year}${b.month}`.localeCompare(`${a.year}${a.month}`)
          })}
          fill
        />
      </div>
    </Box>
  )
}
